module.exports = __webpack_public_path__ + "static/media/icl.da5037ab.jpg";